import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: ""
    }
  }, [_c("el-radio-group", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.auth_status,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "auth_status", $$v);
      },
      expression: "searchForm.auth_status"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: "-1"
    }
  }, [_vm._v("全部")]), _c("el-radio-button", {
    attrs: {
      label: "1"
    }
  }, [_vm._v("待审核")]), _c("el-radio-button", {
    attrs: {
      label: "0"
    }
  }, [_vm._v("待认证")]), _c("el-radio-button", {
    attrs: {
      label: "3"
    }
  }, [_vm._v("认证失败")])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "房源地址"
    }
  }, [_c("el-select", {
    attrs: {
      multiple: ""
    },
    on: {
      change: _vm.getDistrictList
    },
    model: {
      value: _vm.searchForm.cityId,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "cityId", $$v);
      },
      expression: "searchForm.cityId"
    }
  }, _vm._l(_vm.filterList.cityList, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1), _c("el-form-item", [_c("el-select", {
    attrs: {
      multiple: ""
    },
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.districtId,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "districtId", $$v);
      },
      expression: "searchForm.districtId"
    }
  }, _vm._l(_vm.districtList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "房租类型"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.rentTypeId,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "rentTypeId", $$v);
      },
      expression: "searchForm.rentTypeId"
    }
  }, _vm._l(_vm.filterList.rentTypeList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "手机号"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "phone", $$v);
      },
      expression: "searchForm.phone"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "房东姓名"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.name,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "name", $$v);
      },
      expression: "searchForm.name"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: function click($event) {
        _vm.searchForm = {
          auth_status: -1
        };
        _vm.getData("search");
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm
    }
  })], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: "",
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "houseCode",
      label: "房源编号",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.userInfo.scene == 2 ? _c("el-tag", {
          attrs: {
            type: "success",
            size: "small"
          }
        }, [_vm._v("城市大使")]) : _vm._e(), _c("wlc-house-table-number", {
          attrs: {
            type: "".concat(scope.row.auth_info.version == 2 ? "primary" : "info"),
            number: scope.row.houseCode,
            id: scope.row.id
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "姓名",
      width: "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var _ref$row = _ref.row,
          userInfo = _ref$row.userInfo,
          newUser = _ref$row.newUser,
          deviceRiskInfo = _ref$row.deviceRiskInfo;
        return [userInfo.logoutCount > 0 ? _c("el-tag", {
          attrs: {
            size: "small",
            type: "danger"
          }
        }, [_vm._v(" 注销+" + _vm._s(userInfo.logoutCount) + " ")]) : _vm._e(), _c("wlc-user-pop", {
          attrs: {
            info: newUser,
            deviceRisk: "",
            deviceRiskInfo: deviceRiskInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        }), _c("wlc-pop-radar-chart", {
          attrs: {
            info: userInfo.userScore,
            type: userInfo.user_type
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "备注",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-remark-list", {
          attrs: {
            remarkList: scope.row.userInfo.remarkList,
            remark: scope.row.userInfo.remark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "认证信息",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return scope.row.authPay != 0 ? [_c("wlc-house-auth-info", {
          attrs: {
            version: scope.row.auth_info.version,
            houseId: scope.row.id,
            buttonType: scope.row.auth_info.role
          }
        }, [_vm._v(" " + _vm._s(_vm.getAuthRole(scope.row.auth_info.role)) + " ")])] : undefined;
      }
    }], null, true)
  }), _c("el-table-column", {
    attrs: {
      label: "认证状态",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.auth_status == 0 ? _c("el-tag", {
          attrs: {
            type: "danger"
          }
        }, [_vm._v("待认证")]) : _vm._e(), scope.row.auth_status == 1 ? _c("el-tag", {
          attrs: {
            type: "success"
          }
        }, [_vm._v("待审核")]) : _vm._e(), scope.row.auth_status == 2 ? _c("el-tag", {
          attrs: {
            type: "info"
          }
        }, [_vm._v("审核成功")]) : _vm._e(), scope.row.auth_status == 3 ? _c("el-tag", {
          attrs: {
            type: "warning"
          }
        }, [_vm._v("审核失败")]) : _vm._e(), scope.row.hasLandlordAuthRecord ? _c("el-button", {
          staticStyle: {
            position: "absolute",
            bottom: "5px",
            right: "5px"
          },
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.goLandlordAuthRecord(scope.row);
            }
          }
        }, [_vm._v(" 认证记录"), _c("i", {
          staticClass: "el-icon-arrow-right el-icon--right"
        })]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "证件信息",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row$auth_info;
        return [scope.row.auth_info.card_type > 0 ? _c("el-tag", {
          attrs: {
            type: "warning",
            size: "mini"
          }
        }, [_vm._v("非大陆用户")]) : _vm._e(), _c("el-popover", {
          attrs: {
            placement: "top-start",
            content: scope.row.auth_info.idcard_number,
            trigger: "hover"
          }
        }, [_c("el-link", {
          attrs: {
            slot: "reference",
            type: "primary"
          },
          nativeOn: {
            click: function click($event) {
              return _vm.goRealName(scope.row);
            }
          },
          slot: "reference"
        }, [_vm._v(_vm._s(scope.row.auth_info.idcard_name) + " "), (_scope$row$auth_info = scope.row.auth_info) !== null && _scope$row$auth_info !== void 0 && _scope$row$auth_info.idcard_name && scope.row.userInfo.auth_info_account && scope.row.userInfo.auth_info_account.length > 1 ? _c("span", [_vm._v(" * " + _vm._s(scope.row.userInfo.auth_info_account.length))]) : _vm._e()])], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "用户标签",
      width: "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-user-table-tag", {
          attrs: {
            userId: scope.row.userInfo.id,
            list: scope.row.userTag
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "userInfo.phone",
      label: "手机",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "address",
      label: "详细地址",
      width: "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-house-table-address", {
          attrs: {
            address: scope.row.address,
            addressList: scope.row.addressArr
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "消息数"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-im-count", {
          attrs: {
            count: scope.row.imCount,
            userId: scope.row.userInfo.id
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "authTime",
      label: "缴费时间",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "150",
      align: "center",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.status === 3 ? _c("el-button", {
          staticClass: "wlc-button-succes",
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.auditHouse(scope.row, 4);
            }
          }
        }, [_vm._v("通过 ")]) : _vm._e(), scope.row.status === 3 ? _c("el-button", {
          staticClass: "wlc-button-danger",
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.auditHouseNew(scope.row, 6);
            }
          }
        }, [_vm._v("拒绝 ")]) : _vm._e(), scope.row.status === 3 ? _c("br") : _vm._e(), scope.row.status == 3 ? _c("el-button", {
          attrs: {
            type: "text",
            size: "mini"
          },
          on: {
            click: function click($event) {
              return _vm.updateItem(scope.row);
            }
          }
        }, [_vm._v("编辑 ")]) : _vm._e(), _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.setRemarkDialog(scope.row);
            }
          }
        }, [_vm._v(" 备注 ")]), scope.row.auth_status == 0 || scope.row.auth_status == 3 ? _c("wlc-set-house-type", {
          attrs: {
            className: "wlc-button-danger",
            houseId: scope.row.id,
            userId: scope.row.userInfo.id,
            houseType: 0
          },
          on: {
            refresh: _vm.getData
          }
        }) : _vm._e()];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.ps,
      "current-page": _vm.searchForm.pn,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("wlc-remark", {
    attrs: {
      visible: _vm.remarkDialogVisible,
      userId: _vm.currentRemarkObj.id,
      remark: _vm.currentRemarkObj.remark
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.remarkDialogVisible = $event;
      },
      getData: _vm.getData
    }
  }), _c("refused", {
    attrs: {
      title: "请选择后续操作",
      visible: _vm.refusedVisible,
      "close-on-click-modal": false,
      houseId: _vm.currentHouseId,
      userId: _vm.currentUserId,
      width: "400px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.refusedVisible = $event;
      },
      refresh: _vm.getData
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };